export default "/static/dashboard/build/app/img/v2/dd2d55a8f6497907d9b20d2dfe86d9e4.png";